import { BrokerTeamList } from '@insurance/api/requests'
import { MenuProps } from 'antd'
import { TFunction } from 'i18next'
import { Edit2, Trash } from 'iconsax-react'

import { TeamActionsTypes } from '../TeamsActions'

const iconProps = {
  size: 16
}

export const getActionColumnMenu =
  (
    onClick: (
      modal: {
        type: TeamActionsTypes
        data: BrokerTeamList
      } | null
    ) => void,
    t: TFunction
  ) =>
  (data: BrokerTeamList): MenuProps['items'] => {
    return [
      {
        label: t('edit'),
        key: 'edit',
        icon: <Edit2 {...iconProps} />,
        onClick: () => onClick({ data, type: 'edit' })
      },
      {
        type: 'divider'
      },
      {
        label: t('delete'),
        key: 'delete',
        icon: <Trash {...iconProps} />,
        danger: true,
        onClick: () => onClick({ data, type: 'delete' })
      }
    ]
  }
